import moment from 'moment';
import ReactPaginate from 'react-paginate';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useLocation, useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Box, Flex, Text, Center, Table, Thead, Tbody, Tfoot, Tr, Th, Td, Badge, Tooltip, Button, Checkbox } from '@chakra-ui/react';
import { faSlidersH, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { gql, useLazyQuery } from '@apollo/client';
import useStore from '../../../store';
import c from '../../../constant';
import { useCallback } from 'react';
import LoadingTable from '../../Table/Loading';
import { SectionHeader } from '../../Other';
import ComplaintPrint from './ComplaintPrint';
let maxLimit = 300;
let minLimit = 10;
let offset = 0;
const limit = 10;
let fromDate = null;
let toDate = null;
let read = null;
let spam = false;
let status = 'all';
const QUERY_COMPLAINTS = gql`
	query getComplaintss(
		$offset: Float
		$limit: Float
		$fromDate: DateTime
		$toDate: DateTime
		$read: Boolean
		$spam: Boolean
		$adminStatus: String
		$companyId: String!
	) {
		getComplaints(
			pagerInput: { limit: $limit, offset: $offset }
			fromDate: $fromDate
			toDate: $toDate
			read: $read
			spam: $spam
			adminStatus: $adminStatus
			companyId: $companyId
		) {
			complaints {
				id
				no
				subject
				description
				createdAt
				complaintFile
				complaintFileSize
				complaintType
				settled
				settledDate
				spam
				notification {
					read
				}
				platform
				adminComplaintStatus
			}
			countUnreadComplaints
			totalPages
			totalRows

			StatusTypes {
				countInProgress
				countWaitingForCompany
				countReceivedCompanyReply
				countProvidedReplyToApplicant
				countApplicantMadeDecision
				countSettled
				countWithdrawn
			}
		}
	}
`;

export default function InstitutionComplaintList(props) {
	const { companyId, onDataChanged, onPrint } = props;
	const { t } = useTranslation();
	const [loadComplaints, { loading, data, error }] = useLazyQuery(QUERY_COMPLAINTS);
	const history = useHistory();
	const [isShowingMore, setShowingMore] = useState(false);

	const runQuery = useCallback(() => {
		const varirables = {
			offset: offset,
			limit: isShowingMore ? maxLimit : minLimit,
			fromDate: fromDate,
			toDate: toDate,
			read: read,
			spam: spam,
			adminStatus: status,
			companyId: companyId,
		};
		loadComplaints({ variables: varirables });
	}, [companyId, loadComplaints, isShowingMore]);

	useEffect(() => {
		runQuery();
	}, [runQuery]);

	useEffect(() => {
		if (data?.getComplaints) {
			// console.log('complaints data:', data?.getComplaints);
			onDataChanged(data);
		}
	}, [data]);

	function getPlatformbadge(platform) {
		switch (platform) {
			case 'mobile':
				return (
					<Badge ml={1} colorScheme="blue">
						{t('Mobile')}
					</Badge>
				);
			case 'web':
				return (
					<Badge ml={1} colorScheme="purple">
						{t('Website')}
					</Badge>
				);
			default:
				return (
					<>
						{/* <Badge ml={1} colorScheme="yellow">
								{t('old complaint')}
							</Badge> */}
						<Badge ml={1} colorScheme="purple">
							{t('Website')}
						</Badge>
					</>
				);
		}
	}

	function getStatus({ settled, settledDate }, adminComplaintStatus) {
		if (settled === true) {
			return (
				<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
					<Badge colorScheme="green">{t('Settled')}</Badge>
				</Tooltip>
			);
		} else {
			switch (adminComplaintStatus) {
				case 'IN_PROGRESS':
					return <Badge colorScheme="red">{t('In progress')}</Badge>;
				case 'WAITING_FOR_COMPANY_REPLY':
					return <Badge colorScheme="yellow">{t('Waiting for company reply')}</Badge>;
				case 'RECIEVED_COMPANY_REPLY':
					return <Badge colorScheme="teal">{t('Received company reply')}</Badge>;
				case 'PROVIDED_REPLY_LETTER_TO_APPLICANT':
					return <Badge colorScheme="purple">{t('Provided reply letter to applicant')}</Badge>;
				case 'APPLICANT_MADE_DECISION':
					return <Badge colorScheme="blue">{t('Applicant made decision')}</Badge>;
				case 'SETTLED':
					return (
						<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
							<Badge colorScheme="green">{t('Settled')}</Badge>
						</Tooltip>
					);
				case 'WITHDRAWN':
					return <Badge colorScheme="gray">{t('Withdrawn')}</Badge>;
				default:
					return '-';
			}
		}
	}

	function onPageChange(value) {
		offset = value * (isShowingMore ? maxLimit : minLimit);
		runQuery();
	}

	function onShowingMore() {
		offset = 0;
		setShowingMore(!isShowingMore);
	}

	return (
		<>
			<Flex mt={6} className="hidden-print" {...props}>
				<Box width="100%">
					<SectionHeader title={t('Other Complaint')} />
					<Center mt={4}>
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb={4}
						>
							<Flex
								h="48px"
								p={4}
								pt={0}
								pb={0}
								mb={4}
								bg="#FAFAFA"
								alignItems="center"
								justifyContent="flex-end"
								borderBottom="1px solid #dbdbdb"
							>
								{/* <Flex alignItems="center">
									<Button onClick={() => runQuery()}>reload query</Button>
								</Flex> */}
								<Flex alignItems="center">
									<Button
										mr="2"
										onClick={onPrint}
										leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
										colorScheme="gray"
										variant="solid"
										size="sm"
										borderRadius={c.borderRadius}
										border="1px solid #bdc3c7"
									>
										{t('Print')}
									</Button>
								</Flex>
							</Flex>
							<Box p="16px">
								<Table variant="simple">
									<Tbody>
										<Tr>
											<Th>{t('Number')}</Th>
											<Th>{t('Subject')}</Th>
											<Th>{t('Created At')}</Th>
											<Th>{t('Platform')}</Th>
											<Th isNumeric>{t('Status')}</Th>
										</Tr>

										{loading && <LoadingTable column={4} />}
										{data?.getComplaints?.complaints.length <= 0 && (
											<Tr>
												<Td>
													<Text>{t('No Data')}</Text>
												</Td>
											</Tr>
										)}
										{data?.getComplaints?.complaints?.map((complaint, index) => {
											return (
												<Tr
													cursor="pointer"
													_hover={{ bg: 'gray.200' }}
													onClick={() => {
														complaint.adminComplaintStatus !== null
															? history.push(`/complaint/new-detail?id=${complaint.id}`)
															: history.push(`/complaint/detail?id=${complaint.id}`);
													}}
													key={`complaint-${index}`}
													bg={complaint?.notification?.read === false ? 'gray.100' : 'white'}
												>
													<Td>{complaint.no}</Td>
													<Td fontWeight="500">
														<Text maxW="400px" noOfLines={4}>
															{complaint.subject}
														</Text>
													</Td>
													<Td>{moment(complaint.createdAt).format('LLLL')}</Td>
													<Td>
														{/* {complaintType(complaint.complaintType)} */}
														{getPlatformbadge(complaint?.platform)}
													</Td>
													<Td isNumeric>
														{complaint.spam === false &&
															getStatus(
																{ settled: complaint.settled, settledDate: complaint.settledDate },
																complaint.adminComplaintStatus,
															)}
														{complaint.spam === true && <Badge colorScheme="red">{t('Spam')}</Badge>}
													</Td>
												</Tr>
											);
										})}
									</Tbody>
									<Tfoot>
										<Tr>
											<Th>{t('Number')}</Th>
											<Th>{t('Subject')}</Th>
											<Th>{t('Created At')}</Th>
											<Th>{t('Platform')}</Th>
											<Th isNumeric>{t('Status')}</Th>
										</Tr>
										<Tr>
											<Th />
											<Th />
											<Th />
											<Th />
											<Th isNumeric>
												{t('Total Rows')}: {data?.getComplaints?.totalRows}
											</Th>
										</Tr>
									</Tfoot>
								</Table>
								<Flex className="hidden-print" justifyContent="flex-end" w="100%" mt="4">
									{data?.getComplaints?.totalPages > 1 && (
										<ReactPaginate
											previousLabel={<ChevronLeftIcon fontSize="20px" />}
											nextLabel={<ChevronRightIcon fontSize="20px" />}
											breakLabel={'...'}
											breakClassName={'break-me'}
											pageCount={data?.getComplaints?.totalPages}
											marginPagesDisplayed={2}
											pageRangeDisplayed={3}
											disableInitialCallback={true}
											onPageChange={({ selected }) => onPageChange(selected)}
											containerClassName={'pagination'}
											activeClassName={'active'}
											initialPage={offset / (isShowingMore ? maxLimit : minLimit)}
										/>
									)}
								</Flex>
								{data?.getComplaints?.complaints.length > 0 && (
									<Flex justifyContent="flex-end" mt="6">
										<Text mr="2">{t('Show more rows')}</Text>
										<Checkbox isChecked={isShowingMore} onChange={onShowingMore}></Checkbox>
									</Flex>
								)}
							</Box>
						</Box>
					</Center>
				</Box>
			</Flex>
			{data && <ComplaintPrint data={data} />}
		</>
	);
}
